import React from "react";
import {Field} from "formik";
import {IconButton, InputBase, Paper, TextField} from "@material-ui/core";
import style from "./style";
import Switch from "@material-ui/core/Switch/Switch";
import {DatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Slider from "rc-slider";
import Input from "@material-ui/core/Input";
import InputMask from "react-input-mask";
import "rc-slider/assets/index.css";
import format from "date-fns/format";
import Search from "@material-ui/icons/Search";
import moment from "moment";

class FrDateFnsUtils extends DateFnsUtils {
    startOfMonth(date) {
        return moment(date).startOf('month').toDate();
    }

    getDatePickerHeaderText(date) {
        return format(date, 'MMM dd, yyyy', {locale: this.locale})
    }
}

class InputField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedDate: null,
            checked: false
        };
    }

    selectDate = value => {
        this.setState({selectedDate: value});
    };

    handleCheckBox = () => {
        this.setState({checked: !this.state.checked});
    };

    render() {
        const {
            id,
            error,
            errorMessage,
            placeholder,
            name,
            type,
            onChange,
            fieldType,
            onKeyPress,
            onKeyDown,
            value
        } = this.props;

        const InputField = this.Field;

        if (type === "search") {
            return (
                <Paper elevation={1} style={{borderRadius: 30, paddingLeft: 25}}>
                    <IconButton>
                        <Search/>
                    </IconButton>
                    <InputBase
                      autoComplete="off"
                        onChange={onChange}
                        onKeyPress={onKeyPress ? onKeyPress : () => {}}
                        onKeyDown={onKeyDown ? onKeyDown : () => {}}
                        placeholder={placeholder}
                        style={{fontFamily: "Poppins", overflow: 'hidden', outline: 'none'}}
                        id={id ? id : ''}
                    />
                </Paper>
            );
        }
        if (type == "error") {
            return <p style={style.error}>{error ? errorMessage : ""}</p>;
        }
        if (fieldType == "formInput") {
            return <InputField {...this.props} />;
        }

        return (
            <Field
                name={name}
                render={({field}) => {
                    return <InputField {...field} />;
                }}
            />
        );
    }

    Field = field => {
        const {
            error,
            errorMessage,
            placeholder,
            name,
            label,
            type,
            screen,
            defaultValue,
            onSliderValueChange,
            onSliderDrag,
            onSliderDragEnd,
            hideLabel,
            inputType,
            masked,
            mask,
            value,
            handleCheckbox,
            checked,
            onChange,
            onTextChange,
            multiline,
            rows,
            onBlur,
            disabled,
            fullWidth,
            onPickerOpen,
            InputProps = {
                form: {
                    autocomplete: 'off'
                }
            },
            fieldType
        } = this.props;

        return (
            <div style={style.fieldContainer}>
                {!hideLabel && <p style={style.labelText}>{label}</p>}
                {type === "textarea" && !masked && (
                  <TextField
                    fullWidth
                    multiline={true}
                    rows={rows}
                    error={error}
                    placeholder={placeholder}
                    disabled={disabled}
                    {...field}
                  />
                )}
                {type === "text" && !masked && (
                    <TextField
                        fullWidth
                        multiline={multiline}
                        rows={rows}
                        error={error}
                        inputProps={{min: 0}}
                        InputProps={InputProps}
                        placeholder={placeholder}
                        type={inputType ? inputType : "text"}
                        disabled={disabled}
                        {...field}
                    />
                )}
                {type === "text" && masked && (
                    <InputMask
                        mask={mask}
                        {...field}
                        name={name}
                        maskChar={" "}
                        style={{width: "100%"}}
                        placeholder={placeholder}
                        onBlur={onBlur ? onBlur : () => {}}
                    >
                        {inputProps => <Input {...inputProps} type={"text"}/>}
                    </InputMask>
                )}
                {type === "checkbox" && (
                    <div style={{display: "flex", justifyContent: "space-between", alignItems: 'center'}}>
                        <p style={style.switchLabelText}>{label}</p>
                        <Switch
                            checked={checked}
                            name={name}
                            value={checked ? "true" : "false"}
                            onChange={handleCheckbox}
                        />
                    </div>
                )}
                {type === "date" && (
                    <MuiPickersUtilsProvider utils={FrDateFnsUtils}>
                        <DatePicker
                            name={name}
                            format="MM/dd/yyyy"
                            placeholder="MM/DD/YYYY"
                            {...field}
                            value={new Date(value)}
                            style={{width: "100%"}}
                            onChange={onChange}
                            onOpen={onPickerOpen}
                        />
                    </MuiPickersUtilsProvider>
                )}
                {!screen && type === "slider" && (
                    <Slider
                        defaultValue={30}
                        value={defaultValue}
                        style={{marginTop: 10}}
                        name={name}
                        onChange={onSliderValueChange}
                        onBeforeChange={onSliderDrag}
                        onAfterChange={onSliderDragEnd}
                        max={100}
                        step={5}
                        handleStyle={{
                            backgroundColor: "#ff8000",
                            borderColor: "#ff8000"
                        }}
                        trackStyle={{backgroundColor: "#ff8000"}}
                        marks={{0: 0, [defaultValue]: defaultValue, 100: 100}}
                    />
                )}

                {!!screen && screen === "chef-filter" && type === "slider" && (
                  <Slider
                    defaultValue={50}
                    value={defaultValue}
                    style={{marginTop: 10}}
                    name={name}
                    onChange={onSliderValueChange}
                    onBeforeChange={onSliderDrag}
                    onAfterChange={onSliderDragEnd}
                    min={50}
                    max={10000}
                    step={10}
                    handleStyle={{
                        backgroundColor: "#ff8000",
                        borderColor: "#ff8000"
                    }}
                    trackStyle={{backgroundColor: "#ff8000"}}
                    marks={{50: {style: { left: -5 }, label: 50}, [defaultValue]: defaultValue, 10000: {style: {left: '95%'}, label: 10000}}}
                  />
                )}

                {!!screen && screen === "dish-filters" && type === "slider" && (
                  <Slider
                    defaultValue={0}
                    value={defaultValue}
                    style={{marginTop: 10}}
                    name={name}
                    onChange={onSliderValueChange}
                    onBeforeChange={onSliderDrag}
                    onAfterChange={onSliderDragEnd}
                    min={0}
                    max={1000}
                    step={5}
                    handleStyle={{
                        backgroundColor: "#ff8000",
                        borderColor: "#ff8000"
                    }}
                    trackStyle={{backgroundColor: "#ff8000"}}
                    marks={{0: {style: { left: -20 }, label: 0}, [defaultValue]: defaultValue, 1000: {style: {left: '110%'}, label: 1000}}}
                  />
                )}
                {error && <p style={style.error}>{errorMessage}</p>}
            </div>
        );
    };
}

export default InputField;
